import {
  Table,
  Form,
  Spinner,
  Dropdown,
  Pagination,
  Card,
  Alert,
  // <JC
  Button
  // JC>
} from "react-bootstrap";
import React from "react";
import { store } from "../reducer/Store";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Image from "react-bootstrap/Image";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";

const TableDynamic = ({
  controlTableId = "",
  columnsName,
  columns,
  data,
  showUpdate,
  dataPagination,
  getDataPagination,
  updateState,
  search,
  noResultMessage,
  deleteD,
  deleteDbulk,
  setNoResultMessage,
  setDetailsPlan,
  duplicatePlanOrCustomersList,
  setShowDetailsPlan,
  checkedCustomersListIds,
  setCheckedCustomersListIds,
  customClassName = "",

}) => {
  const { dispatch, state } = React.useContext(store);
  const [filterData, setFilterData] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState("");

  
  // <JC
  const [checkedIds, setcheckedIds] = React.useState([]);
  const [isAllChecked, setIsAllChecked] = React.useState(
    state.listBrands.slice(1)
  );
  function renderAppplicatedPlans(item) {
    if (item.type === 'type1') {
      return <div>{item.name}</div>;
    }
    return null;
  }
  // JC>

  /**
   * Cette fonction gère la recherche et le filtrage des données.
   * Elle prend en paramètre la valeur de recherche.
   * Si la valeur de recherche a une longueur supérieure ou égale à 3, elle lance la recherche en appelant la fonction search avec la valeur en minuscules.
   * Si la valeur de recherche a une longueur inférieure à 3, elle réinitialise les résultats de recherche et récupère les données paginées.
   * @param {string} value - La valeur de recherche
   * @returns {void}
   */
  const searchFilter = (value) => {
    setSearchValue(value);
    if (value.length >= 2) {
      search(value.toLowerCase());
    }

    if (value.length < 2) {
      setNoResultMessage(false);
      getDataPagination();
    }
  };

  React.useEffect(() => {
    setFilterData(data);
  }, [data]);

  //console.log(data);

  React.useEffect(() => {
    if (searchValue) {
      searchFilter("");
    }
  }, [state.currentBrands, state.currentYear]);

  // <JC
  // Cases à cocher quand on clique sur "Tout sélectionner"
  if(data !== undefined){
    data.map((column, key) => (
      !isAllChecked.includes(column.id) ? isAllChecked.push(column.id) : ""
    ));
  }
  // JC>
  
  const dataToShow = (values, key, column, k) => {
    switch (column) {
      case "brand":
        return values[column].name;
      case "interlocutor_role":
        return values[column].name;
      case "operation_plv_type":
        return values[column].name;
      case "manufacturing":
        return (
          <Form>
            <Form.Check
              type="switch"
              checked={values.manufacturing === 1 ? true : false}
              disabled={
                parseInt(localStorage.getItem("user_role")) !== 5 &&
                parseInt(localStorage.getItem("user_role")) !== 6
                  ? false
                  : true
              }
              onClick={() => {
                updateState(values, "manufacturing");
              }}
              readOnly
              id={`custom-switch-manufacturing-${k * key}`}
              label={values.manufacturing === 1 ? "Oui" : "Non"}
            />
          </Form>
        );
      case "for_all_customer":
        return (
          <Form>
            <Form.Check
              className={values.for_all_customer === 1 ? "blue" : ""}
              type="switch"
              checked={values.for_all_customer === 1 ? true : false}
              onClick={() => {
                updateState(values);
              }}
              readOnly
              id={`custom-switch-for_all_customer-${k * key}`}
              label={"Par défault"}
            />
          </Form>
        );
      case "passing":
        return (
          <Form>
            <Form.Check
              type="switch"
              checked={values.passing === 1 ? true : false}
              onClick={() => {
                updateState(values, "passing");
              }}
              disabled={
                parseInt(localStorage.getItem("user_role")) !== 5 &&
                parseInt(localStorage.getItem("user_role")) !== 6
                  ? false
                  : true
              }
              readOnly
              id={`custom-switch-passing-${k * key}`}
              label={values.passing === 1 ? "Oui" : "Non"}
            />
          </Form>
        );
      case "active_customers":
        return (
          <Form>
            <Form.Check
              type="switch"
              checked={values.active === 1 ? true : false}
              onClick={() => {
                updateState(
                  values,
                  dataPagination.current_page,
                  dataPagination.per_page,
                  searchValue
                );
              }}
              readOnly
              id={`custom-switch-${k * key}`}
              label={values.active === 1 ? "Actif" : "Inactif"}
            />
          </Form>
        );
      case "status":
        return values[column] ? values[column] : "";
      case "group":
        return values[column] ? values[column].name : "";
      case "content":
      case "image":
        return (
          <Image
            src={`data:image/png;base64,${values[column]}`}
            width={column === "content" ? "150" : "50"}
          />
        );
      case "updateAndDeletePlan":
      case "updateAndDelete":
        if (
          parseInt(localStorage.getItem("user_role")) !== 5 &&
          parseInt(localStorage.getItem("user_role")) !== 6
        ) {
          return (
            <Dropdown className="d-flex justify-content-end">
              <Dropdown.Toggle>
                <MoreVertIcon />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {column === "updateAndDeletePlan" && (
                  <>
                    <Dropdown.Item
                      onClick={() => {
                        setDetailsPlan(values);
                        setShowDetailsPlan(true);
                      }}
                    >
                      <VisibilityOutlinedIcon className="grey" /> Consulter
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        duplicatePlanOrCustomersList(values.id);
                      }}
                    >
                      <ContentCopyOutlinedIcon className="grey" /> Dupliquer
                    </Dropdown.Item>
                  </>
                )}
                <Dropdown.Item
                  onClick={() => {
                    controlTableId.includes("planslist")
                      ? showUpdate(
                          values,
                          dataPagination.current_page,
                          dataPagination.per_page,
                          searchValue
                        )
                      : showUpdate(values);
                  }}
                >
                  <EditOutlinedIcon className="grey" /> Modifier
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    deleteD(values);
                  }}
                >
                  <DeleteOutlinedIcon className="red" /> Supprimer
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        }
        break;
      case "id":
        if (controlTableId.includes("planslistDetailsPlain")) {
          return (
            <Form className="p-3">
              <Form.Check
                key={`${k}-${values[column]}`}
                name="customersList"
                type="checkbox"
                id={`checkbox-${k}-${values[column]}`}
                value={
                  checkedCustomersListIds.includes(values[column])
                    ? true
                    : false
                }
                checked={
                  checkedCustomersListIds.includes(values[column])
                    ? true
                    : false
                }
                readOnly
                onClick={() => {
                  var tabChecked = [...checkedCustomersListIds];
                  if (checkedCustomersListIds.includes(values[column])) {
                    var index = tabChecked.indexOf(values[column]);
                    tabChecked.splice(index, 1);
                    setCheckedCustomersListIds(tabChecked);
                  } else {
                    tabChecked.push(values[column]);
                    setCheckedCustomersListIds(tabChecked);
                  }
                }}
              />
            </Form>
          );
        }
        {
          return values[column];
        }
      default:
        if (
          controlTableId.includes("planslist") &&
          controlTableId !== "planslistDetailsPlain"
        ) {
          return (
            <>

              {/*
              <JC
              Cases à cocher
              */}
              <Form.Check
                key={`table-item-${values.id}`}
                /*
                label={`${elt.id} ${elt.name}`}
                name="customersList"
                
                id={`checkbox-${k}-${elt.name}`}
                */
                type="checkbox"
                value={
                  checkedIds.includes(values.id)
                    ? true
                    : false
                }
                checked={
                  checkedIds.includes(values.id)
                    ? true
                    : false
                }
                readOnly
                inline
                onClick={() => {
                  var tabChecked = [...checkedIds];
                  
                  if (checkedIds.includes(values.id)) {
                    var index = tabChecked.indexOf(values.id);
                    tabChecked.splice(index, 1);
                    setcheckedIds(tabChecked);
                  } else {
                    tabChecked.push(values.id);
                    setcheckedIds(tabChecked);
                  }
                }}
              />
              {/* JC> */}
              

              <div
                variant="none"
                className="button-like-link d-inline"
                onClick={() => {
                  setDetailsPlan(values);
                  setShowDetailsPlan(true);
                }}
              >
                
                {values[column]}
                {controlTableId.includes("planslistCustomer") &&
                  column !== "updateAndDeletePlan" && (
                    <>
                      <span className="blue">
                        {" - " +
                          values.customer_customer_lists.length +
                          " clients"}
                      </span>
                      <>
                        {/*
                        <JC
                        N'affiche qu'un seul plan (le dernier appliqué)
                        */}
                        {values.customer_list_plans.length > 0 ? (
                            <div className="grey fw-bolder">
                              {"- " + values.customer_list_plans[0].brand_name + " : "}
                              <span className="grey fw-normal">{values.customer_list_plans[0].name}</span>
                            </div>
                          
                        ):('')}
                        {/*values.customer_list_plans.length > 0 &&
                          values.customer_list_plans.map((e, k) => (
                            <div className="grey fw-bolder" key={k}>
                              {"- " + e.brand_name + " : "}
                              <span className="grey fw-normal">{e.name}</span>
                            </div>
                          ))*/}
                        {/* JC> */}
                      </>
                    </>
                  )}
              </div>
              </>
          );
        } else {
          return values[column];
        }
    }
  };

  return (
    <>
      {data && data.length > 0 ? (
        <>
          {controlTableId.includes("customers") ||
          controlTableId.includes("planslist") ? (
            <Form className="d-flex mb-3">
              <Form.Control
                type="search"
                value={searchValue}
                onChange={(e) => searchFilter(e.target.value)}
                placeholder={
                  controlTableId.includes("planslist")
                    ? "Rechercher"
                    : "Rechercher client/code tiers"
                }
                className="search mw280 no-border rounded"
                aria-label="Search"
              />
            </Form>
          ) : (
            ""
          )}

          <div className={`table-dynamic card ${customClassName}`}>
            {!state.loader && filterData ? (
              <Table
                responsive={
                  controlTableId === "KamNotResponsive" ? false : true
                }
              >
                <thead>
                  <tr>
                    {columnsName.map((column, key) => (
                      <th key={key}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {noResultMessage ? (
                    <tr>
                      <td colSpan={5}>Aucun résultat trouvé...</td>
                    </tr>
                  ) : (
                    filterData.map((values, key) => (
                      <tr key={key}>
                        {columns.map((column, k) => (
                          <td
                            key={k}
                            className={
                              controlTableId === "interlocutors"
                                ? "interlocutors"
                                : ""
                            }
                          >
                            {dataToShow(values, key, column, k)}
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
                {(controlTableId.includes("customers") ||
                  controlTableId.includes("planslist")) &&
                !noResultMessage ? (
                  <tfoot>
                    <tr>
                      {columns.map((column, key) => (
                        <td
                          key={key}
                          className={
                            columns.length - 1 === key
                              ? "d-flex justify-content-end"
                              : ""
                          }
                        >
                          {columns.length - 1 === key ? (
                            <Pagination size="sm">
                              <Pagination.First
                                onClick={() => {
                                  getDataPagination(
                                    dataPagination.first_page,
                                    dataPagination.per_page,
                                    searchValue
                                  );
                                }}
                                disabled={
                                  dataPagination.current_page === 1
                                    ? true
                                    : false
                                }
                              />
                              <Pagination.Prev
                                onClick={() => {
                                  getDataPagination(
                                    dataPagination.current_page - 1,
                                    dataPagination.per_page,
                                    searchValue
                                  );
                                }}
                                disabled={
                                  dataPagination.current_page === 1
                                    ? true
                                    : false
                                }
                              />
                              <Pagination.Item disabled>
                                {dataPagination.current_page}/
                                {dataPagination.last_page}
                              </Pagination.Item>
                              <Pagination.Next
                                onClick={() => {
                                  getDataPagination(
                                    dataPagination.current_page + 1,
                                    dataPagination.per_page,
                                    searchValue
                                  );
                                }}
                                disabled={
                                  dataPagination.current_page ===
                                  dataPagination.last_page
                                    ? true
                                    : false
                                }
                              />
                              <Pagination.Last
                                onClick={() => {
                                  getDataPagination(
                                    dataPagination.last_page,
                                    dataPagination.per_page,
                                    searchValue
                                  );
                                }}
                                disabled={
                                  dataPagination.current_page ===
                                  dataPagination.last_page
                                    ? true
                                    : false
                                }
                              />
                            </Pagination>
                          ) : (
                            ""
                          )}
                        </td>
                      ))}
                    </tr>

                    {/*
                    <JC
                    Sélectionner toutes les cases à cocher
                    */}
                    {(columnsName[0] && columnsName[0] != 'Code tiers') ? (
                    <tr>
                      <td>
                        
                          <Form.Check
                            key={columnsName[0]}
                            label={`Tout sélectionner`}
                            name={columnsName[0]}
                            type="checkbox"
                            id={columnsName[0]}
                            inline
                            value={
                              isAllChecked.length === checkedIds.length
                                ? true
                                : false
                            }
                            checked={
                              isAllChecked.length === checkedIds.length
                                ? true
                                : false
                            }
                            readOnly
                            onClick={() => {
                              if (isAllChecked.length === checkedIds.length) {
                                setcheckedIds([]);
                              } else {
                                setcheckedIds(isAllChecked);
                              }
                            }}
                          />
                          {checkedIds.length > 0 ? (
                            <Button variant="danger" type="submit"
                              onClick={() => {
                                deleteDbulk(checkedIds);
                              }}
                            >
                              Supprimer la selection
                            </Button>
                          ):( '' )}
                        </td>
                  </tr>
                  ):( '' )}
                  {/* JC> */}

                  </tfoot>
                ) : (
                  ""
                )}



              </Table>
            ) : (
              <div className="text-center">
                <Spinner
                  animation={state.loader ? "border" : false}
                  role="status"
                ></Spinner>
              </div>
            )}
          </div>
        </>
      ) : state.loader ? (
        <div className="text-center">
          <Spinner
            animation={state.loader ? "border" : false}
            role="status"
          ></Spinner>
        </div>
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="info" className="m-0">
              La liste est vide.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
};
export default TableDynamic;
